import type { PricingCatalogFeature } from 'app/services/pricingCatalog';

export const formatFeatureValue = (feature: PricingCatalogFeature): string => {
  switch (feature.availability) {
    case 'limited':
      if (!feature.unit) {
        return `${feature.value}`;
      }
      return feature.unit.startsWith('/')
        ? `${feature.value}${feature.unit}`
        : `${feature.value} ${feature.unit}`;
    case 'unlimited':
      return 'Ilimitado';
    case 'included':
      return 'Incluso';
    case 'addon':
      return 'Add-on';
    case 'unavailable':
    default:
      return '—';
  }
};
